import { isArray } from 'util';

export function prettifyErrorMessage(message) {
    
    if(isArray(message)) {
        let errorTemplate = '<ul>'

        for(const msg of message) {
            errorTemplate += `<li>${msg}</li>`
        }

        errorTemplate += '</ul>'

        return errorTemplate
    } else {
        return message
    }
}